import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineLite} from "gsap";
import {PearlHarbor} from "../PearlHarbor";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {PearlHarborHelper} from "../utils/PearlHarborHelper";
import {APIBetEventData, APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";
import {PearlHarborGameMode} from "../server/PearlHarborGameMode";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class PearlHarborNormalBetPresentation implements FlowStatePresentation {
    constructor() {
        PearlHarbor.apiPlugin.events.on(APIEvent.BET, (data: APIFeatureBetEventData) => PearlHarborNormalBetPresentation.onBet(data));
    }
    public start(flowStateController: FlowStateController) {
        PearlHarbor.foregroundElements.enableButton(false);
        PearlHarbor.backgroundElements.stopIdle();
        PearlHarborSoundManager.onNewBet();
        // Fades out total win from previous spin if any
        if(PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.nextMode)){
            return;
        }
        PearlHarbor.totalWinView.abort();

        const tl: TimelineLite = new TimelineLite();
        const delay: number = PearlHarbor.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? PearlHarborGameConfig.reelAllOutStopDelayFastSpin : PearlHarborGameConfig.reelAllOutStopDelay;
        tl.add(() => {
            PearlHarbor.scatterAnimation.onSpinStart();
            PearlHarbor.multiplier.reset();
            PearlHarbor.scatterCounter.reset();
            PearlHarbor.foregroundElements.resetOnNewSpin();
        });
        const startDelay:number = (PearlHarbor.model.data.nextMode === PearlHarborGameMode.NORMAL_AVALANCHE?1:0);
        tl.add(PearlHarbor.allReelsView.mainReelModels[0].start(), startDelay);
        tl.add(PearlHarbor.allReelsView.mainReelModels[1].start(), delay+startDelay);
        tl.add(PearlHarbor.allReelsView.mainReelModels[2].start(), delay * 2+startDelay);
        tl.add(PearlHarbor.allReelsView.mainReelModels[3].start(), delay * 3+startDelay);
        tl.add(PearlHarbor.allReelsView.mainReelModels[4].start(), delay * 4+startDelay);
        tl.add(PearlHarbor.allReelsView.mainReelModels[5].start(), delay * 5+startDelay);
        tl.add(PearlHarbor.allReelsView.mainReelModels[6].start(), delay * 6+startDelay);
        tl.add(()=>PearlHarbor.activeSymbolsBackground.reset(), delay * 6+startDelay);
        tl.add(()=> flowStateController.finish());
    }

    private static onBet(data:APIBetEventData) {
        if (data.type == APIBetType.FEATURE_BET && !(data.playerInteraction.featureName == "BOOSTED_BET" ||data.playerInteraction.featureName == "BOOSTED_BET_2")) {
            PearlHarbor.foregroundElements.turnOffBoost(false);
        }
    }
}